import React from 'react';
import c from './DivFullPage.module.scss';

const DivFullPage = ({ onClick }) => {
  return <div onClick={onClick} className={c.divFullPage} />;
};

export default DivFullPage;
